import React from "react";
import { clearCategories, initPresentationNotes, loadDefaultSurveyNotes, setNotes } from "../../actions/categories";
import { CategoriesStore } from "../../stores/categories";
import { connect } from "../../utils/aj-react";
import { TreeSelector } from "./treeSelector";
import M from "../../strings";
import { Control } from "./forms";
import _ from "underscore";

function getCategoryLabel(n) {
    let prefix = "";
    if (n.category?.level == 0) {
        prefix = M("macroarea") + ": ";
    } else if (n.category?.level == 1) {
        prefix = M("area") + ": ";
    }

    return prefix + n.category?.description ?? "NA";
}

function getCategoryId(n) {
    return n.id;
}

export const PresentationNotesTree = connect(TreeSelector).to(CategoriesStore, 
    (state) => ({
        nodes: state.questionNodes,
        //selectedNodes: state.selectedCategoryIds,
        inputValues: state.inputValues,
        childrenProperty: "children",
    }),
    (props) => ({
        onUpdate: (props, state) => {
            if (_.isFunction(props.onUpdatePresentationNotes)) {
                props.onUpdatePresentationNotes(state.presentationNotes);
            }
        },
    })
)

export class PresentationNotesControl extends Control {

    componentDidMount() {
        const model = this.props.model;
        model.on("property:change", (p, v) => {
            if (p === "survey") {
                loadDefaultSurveyNotes({surveyId: v.id});
            }
        })

        model.once("load", async () => {
            const surveyId = model.get("survey.id");
            if (surveyId) {
                let defaultNotes = null;
                if (model.get("id")) {
                    defaultNotes = model.get("presentationNotes");
                }

                await loadDefaultSurveyNotes({surveyId});
                if (defaultNotes) {
                    initPresentationNotes(defaultNotes);
                }
            }
        })
    }

    componentWillUnmount() {
        clearCategories();
    }

    onUpdatePresentationNotes(n) {
        const model = this.props.model;
        model.set("presentationNotes", n);

        console.log(model.data);
    }

    render() {
        const startsCollapsed = this.props.startsCollapsed ?? false;

        return <PresentationNotesTree 
            startsCollapsed={startsCollapsed} 
            showNotes={true} 
            onUpdatePresentationNotes={this.onUpdatePresentationNotes.bind(this)} 
            disableSelection={true}
            showInput={true}
            inputType={"textarea"}
            inputOnlyOnLeafs={true}
            onInputChange={(id, value) => setNotes(id, value)}
        />
    }

}